export const CREATE_FEATURE_FLAG = 'featureFlag/CREATE_FEATURE_FLAG';
export const GET_FEATURE_FLAGS = 'featureFlag/GET_FEATURE_FLAGS';
export const GET_USER_FEATURE_FLAGS = 'featureFlag/GET_USER_FEATURE_FLAGS';
export const GET_ASSIGNED_USERS = 'featureFlag/GET_ASSIGNED_USERS';
export const UPDATE_SELECTED_FLAG = 'featureFlag/UPDATE_SELECTED_FLAG';